import React, { useMemo } from 'react';
import styled from './index._less';
import { ELoginType } from '../../../enum';
import QrcodeBtn from '../../../image/qrcode-btn.png';
import LoginBtn from '../../../image/login-btn.png';
import Reg from '../../../components/Reg';
import Login from '../../../components/Login';
import Qrcode from '../../../components/Qrcode';
import LoginAgreement from '../../../components/LoginAgreement';
import useLogin from '../../../hooks/use-login';


export default () => {

  const { loginType, changeLoginType, handleSwitchLoginType } = useLogin();

  const LoginContent = useMemo(() => {
    // todo 域名用domain写
    if (loginType === ELoginType.Login) {
      return (
        <>
          <div className="login-title">密码登录</div>
          <Login />
        </>
      )
    }
    if (loginType === ELoginType.Reg) {
      return (
        <>
          <div className="login-title">立即登录 享受优质服务</div>
          <Reg />
        </>
      )
    }
    if (loginType === ELoginType.Qrcode) {
      return (
        <>
          <div className="login-title">扫码登录</div>
          <Qrcode />
        </>
      )
    }
    return <div/>
  }, [loginType])

  return (
      <>
      <div className="right-content">
        <div className="top-switch-icon">
          <img
            onClick={ handleSwitchLoginType }
            src={ loginType === ELoginType.Qrcode ? LoginBtn : QrcodeBtn }
            alt=""
          />
        </div>
        {/* 登录内容区 */}
        <div className="login-content">{ LoginContent }</div>
        {/* 登录底部 */}
        <LoginAgreement />
        {
          loginType === ELoginType.Login
          ? <div className="login-bottom-switch"><span onClick={ () => changeLoginType(ELoginType.Reg) }>验证码登录</span></div>
          : ''
        }
        {
          loginType === ELoginType.Reg
          ? <div className="login-bottom-switch">已有账号<span onClick={ () => changeLoginType(ELoginType.Login) }>密码登录</span></div>
          : ''
        }
      </div>
      <style jsx>{ styled }</style>
    </>
  )
}
